<template>
    <transition name="vpd-fade">
        <div v-if="value" class="vpd-error-overlay">
            <div class="vpd-error-popup">
                <div class="vpd-error-content">
                    <div class="vpd-error-title">
                        nem sikerült a kalkuláció
                    </div>
                    <div class="vpd-error-subtitle">
                        Kérjük, próbáld újra vagy nézd meg számlanyitási ajánlatainkat!
                    </div>
                    <div class="vpd-error-button-container">
                        <div class="base-button" @click="goToKH()">
                            K&H bankszámlák
                        </div>
                        <div class="confirm-button" @click.prevent="recalculate()">
                            <span>újrakalkulálok</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: "vpd-error-dialog",
    props: {
        value: { type: Boolean, default: false },
    },
    methods: {
        goToKH() {
            window.open(
                "https://www.kh.hu/napi-penzugyek/szamla?utm_source=bankszamlakalkulator&utm_medium=errorscreen&utm_campaign=folyoszamla-tactical-owned&utm_content=internal-activity",
                "_blank",
                "noopener,noreferrer"
            )
        },
        async recalculate() {
            window.location.assign("/logout");
        }
    },
};
</script>

<style scoped>
/* Overlay */
.vpd-error-overlay {
    position: fixed;
    inset: 0;
    background: rgba(69, 101, 143, 0.5);
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;
}

/* Popup (desktop) */
.vpd-error-popup {
    width: 500px;
    height: max-content;
    max-height: 350px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 54, 101, 0.16);
    border-radius: 8px;
}


.vpd-error-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px;
    gap: 24px;
    box-sizing: border-box;
}

.vpd-error-title {
    font-family: Nunito;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #0D2A50;
}

.vpd-error-subtitle {
    font-family: Nunito;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #0D2A50;
}

.vpd-error-button-container {
    display: flex;
    flex-direction: row;
    gap: 24px;
}

.confirm-button {
    display: flex;
    justify-content: center;
    width: 186px;
    height: 40px;
    gap: 12px;
    border-radius: 4px;
    padding-top: 8px;
    padding-right: 24px;
    padding-bottom: 8px;
    padding-left: 24px;
    background: #CE447B;
    color: white;
    cursor: pointer;
    font-family: Nunito;
}

.base-button {
    width: 166px;
    min-width: 116px;
    max-width: 288px;
    border-radius: 4px;
    border-width: 1px;
    opacity: 1;
    padding-top: 8px;
    padding-bottom: 8px;
    border: 1px solid #252EAB;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;
    color: #252EAB;
    cursor: pointer;
    font-family: Nunito;
}


/* Mobile: bottom-sheet style */
@media (max-width: 540px) {
    .vpd-error-overlay {
        align-items: flex-end;
        padding-bottom: 16px;
        box-sizing: border-box;
    }

    .vpd-error-popup {
        width: 90%;
        max-width: 350px;
        height: max-content;
        max-height: 440px;
    }

    .vpd-error-content {
        padding: 0px;
        gap: 24px;
    }

    .vpd-error-title {
        padding: 24px 24px 0px 24px;
    }

    .vpd-error-subtitle {
        padding: 0px 24px 0px 24px;
    }


    .vpd-error-button-container {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        gap: 0px;
        width: 100%;
    }

    .confirm-button {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        gap: 12px;
        padding-top: 16px;
        padding-bottom: 16px;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        background: white;
        color: #252EAB;
        border-top: 1px solid #BFDAFF;
        border-bottom: 1px solid #BFDAFF;
    }

    .base-button {
        width: 100%;
        border: none;
        font-weight: 400;
        text-align: center;
        color: #252EAB;
        padding-top: 16px;
        padding-bottom: 16px;
    }
}

/* Fade transition */
.vpd-fade-enter-active,
.vpd-fade-leave-active {
    transition: opacity 0.2s ease;
}

.vpd-fade-enter,
.vpd-fade-leave-to {
    opacity: 0;
}
</style>
